export const SET_SELECTED_PRODUCT = 'FLAT_RATE_OFFERS/SET_SELECTED_PRODUCT';
export const RESET_SELECTED_PRODUCT = 'FLAT_RATE_OFFERS/RESET_SELECTED_PRODUCT';
